import React from "react";
import { ChevronRight } from "lucide-react";
import { beoordeeldTekst, fotoTekst, nietGoedTekst } from "./bezoekUtils";

// Eén regel in een lijst bezoeken; alle tellingen komen van de server.
export const BezoekRij = ({ b, onOpen, zonderLocatie = false, actie }) => (
  <div data-testid={`bezoek-rij-${b.id}`} className="flex items-center gap-2">
    <button type="button" data-testid={`bezoek-open-${b.id}`} onClick={() => onOpen(b)}
      className="flex-1 min-w-0 min-h-[48px] flex items-center gap-3 px-3.5 py-2.5 text-left hover:bg-zinc-50 transition-colors">
      <span className="flex-1 min-w-0 text-sm text-zinc-800">
        {!zonderLocatie && <span className="font-semibold">{b.locatie} · </span>}
        <span className="font-semibold">{b.datumLabel}</span> · {b.omNaam}
        <span className="block sm:inline text-xs sm:text-sm text-zinc-500">
          <span className="hidden sm:inline"> · </span>{beoordeeldTekst(b.beoordeeld)}
          {b.nietGoed > 0 && <span className="text-rose-700 font-semibold"> · {nietGoedTekst(b.nietGoed)}</span>}
          {b.fotoAantal > 0 && <> · {fotoTekst(b.fotoAantal)}</>}
        </span>
      </span>
      <ChevronRight className="h-4 w-4 text-zinc-400 shrink-0" />
    </button>
    {actie}
  </div>
);
